import { WhaleZonesModel } from '../models/whale-zones-model';
import { ZoneFeature } from '../models/zones-base-interfaces';
import { WhaleZonesLayerBase } from './whale-zones-layer-base';

export class WhaleZonesLayerAll extends WhaleZonesLayerBase {
    connectEventHandlers(): void {}
    
    async getZones(): Promise<ZoneFeature[] | null> {
        const zones = await WhaleZonesModel!.allZones();
        return zones;
    }
} 